import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  // ExamSessionSelectionDialog
  dialogTitle: {
    backgroundColor: '#f5f5f5',
  },
  dialogTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
  },
  dialogTitleText: {
    color: theme.palette.text.primary,
  },
  closeButton: {
    color: theme.palette.text.primary,
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    padding: 10,
  },
  actionHint: {
    color: theme.palette.warning.main,
  },
  actionButtons: {
    display: 'flex',
    gap: 8,
    flexShrink: 0,
  },
  actionButton: {
    width: 100,
  },

  // ExamSessionFilters
  sessionCount: {
    color: theme.palette.text.secondary,
  },

  // ExamSessionList

  sessionGroup: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    gap: 6,
    maxHeight: '244px',
    overflowY: 'auto',
    padding: 1,
  },
  sessionOption: {
    width: '100%',
    boxSizing: 'border-box',
    margin: 0,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 0,
    alignItems: 'center',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
  },
  sessionOptionSelected: {
    borderColor: theme.palette.secondary.main,
    boxShadow: `0 0 0 1px ${theme.palette.secondary.main}`,
  },
  sessionOptionLabel: {
    width: '100%',
  },
  sessionOptionContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    width: '100%',
    padding: '3px 10px 3px 0',
  },
  sessionDetails: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
  sessionDate: {
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  sessionMeta: {
    color: theme.palette.text.secondary,
  },
  sessionQuota: {
    color: theme.palette.success.main,
    flexShrink: 0,
    fontWeight: 'bold',
  },
}));
